import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import ValueComponent from '../home/components/value/value.component';
import VisionComponent from '../home/components/vision/vision.component';
import BusinessComponent from '../home/components/business/business.component';
import PhilosophyComponent from '../home/components/philosophy/philosophy.component';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-about-page',
  standalone: true,
  imports: [
    CommonModule,
    ValueComponent,
    VisionComponent,
    BusinessComponent,
    PhilosophyComponent,
  ],
  templateUrl: './about.page.html',
})
export default class AboutPage {
  private readonly seoService = inject(SeoService);

  constructor() {
    this.seoService.set({
      title: '회사소개',
    });
  }
}
